import {
  useContext,
  createContext,
  ReactNode,
  useState,
  useCallback,
} from 'react';

import { useDragAndDrop } from '../components/shared/DragAndDrop/hook/dragAndDrop';

interface IFiltersProviderProps {
  children: ReactNode;
}

type Field = {
  id: string;
  name: string;
};

type FiltersContextData = {
  fields: Field[];
  dropField: () => void;
  removeField: (value: Field) => void;
  clearFields: () => void;
};

const FiltersContext = createContext({} as FiltersContextData);

export function FiltersProvider({ children }: IFiltersProviderProps) {
  const { field } = useDragAndDrop();
  const [fields, setFields] = useState<Field[]>([]);

  const dropField = useCallback(() => {
    const value = field;
    const hasFields = fields.filter(field => field.id === value.id).length > 0;
    if (!hasFields) {
      setFields(state => [...state, value]);
    }
  }, [fields, field]);

  const removeField = useCallback(
    (value: Field) => {
      const newFields = fields.filter(field => field.id !== value.id);
      setFields(newFields);
    },
    [fields],
  );

  // Remover tudo
  const clearFields = useCallback(() => {
    setFields(() => []);
  }, []);

  return (
    <FiltersContext.Provider
      value={{ fields, dropField, removeField, clearFields }}
    >
      {children}
    </FiltersContext.Provider>
  );
}

export const useFilters = () => useContext(FiltersContext);
